import curry from "ramda/es/curry";
import pathEq from "ramda/es/pathEq";
export const skipForMiddleware = curry((middlewareName, apiAction)=>pathEq(true, [
        'middlewares',
        middlewareName,
        'skip'
    ], apiAction));
